import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessConnection } from "@/shared/types/api/business-mode.types"

export const getConnectionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessConnection"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      // The backend answers 204 when the user has not linked a business account yet,
      // which fetchBaseQuery surfaces as `data: null` — a successful "not connected"
      // result that must stay distinguishable from a failed request.
      getConnection: builder.query<BusinessConnection | null, void>({
        query: () => `/api/v1/business/connections`,
        providesTags: () => [{ type: "BusinessConnection" as const }]
      })
    })
  })

export const { useGetConnectionQuery } = getConnectionApi
